import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseList } from '../../classes/base-list';
import { deleteEmptyData } from '../../config/app-utils';
import { CiudadService } from '../../services/ciudad.service';
import { DominioService } from '../../services/dominio.service';
import { OficinaComercialService } from '../../services/oficina-comercial.service';
import { SolicitudRegistroService } from '../../services/solicitud-registro.service';
import { NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-registro-online',
  templateUrl: './registro-online.component.html'
})
export class RegistroOnlineComponent implements OnInit {

  dataForm: FormGroup;

  tiposDocumentos: BaseList = new BaseList();

  oficinasComerciales: BaseList = new BaseList();

  sexoList: BaseList = new BaseList();

  estadoCivilList: BaseList = new BaseList();

  ciudadList: BaseList = new BaseList();

  placement = 'bottom';

  model: NgbDateStruct;

  constructor(private service: SolicitudRegistroService, private toastr: ToastrService,
    private fb: FormBuilder, private dominioService: DominioService, private oficinaComercialService: OficinaComercialService,
    private ciudadService: CiudadService, private router: Router, config: NgbDatepickerConfig) {
    this.listarTiposDocumentos();
    this.listarOficinasComerciales();
    this.listarSexo();
    this.listarCiudades();
    this.listarEstadoCivil();

    let date = new Date();
    config.minDate = {year: date.getFullYear() - 50, month: 1, day: 1};
    config.maxDate = {year: date.getFullYear(), month: 12, day: 31};
  }

  ngOnInit() {

    let date:any = document.getElementById('date');

    function checkValue(str, max) {
      if (str.charAt(0) !== '0' || str == '00') {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
      };
      return str;
    };

    date.addEventListener('input', function (e) {
      date.type = 'text';
      var input = date.value;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function (v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = checkValue(values[0], 31);
      if (values[1]) values[1] = checkValue(values[1], 12);
      var output = values.map(function (v, i) {
        return v.length == 2 && i < 2 ? v + ' / ' : v;
      });
      date.value = output.join('').substr(0, 14);
    });

    window.scrollTo(0, 0);
    this.dataForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      tipoDocumento: ['', Validators.required],
      valorDocumento: ['', Validators.required],
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      numeroTelefono: ['', Validators.required],
      oficinaComercialId: ['', Validators.required],
      direccion: ['', Validators.required],
      sexo: ['', Validators.required],
      estadoCivil: [''],
      fechaNacimiento: ['', Validators.required],
      termino: ['', Validators.required],
      cuidadId: ['', Validators.required],
    })
  }

  listarCiudades() {
    let data = {
      count: -1,
      sortBy: "nombre",
      sortOrder: "ASC"
    }
    this.ciudadService.listar(data).subscribe(
      resp => {
        this.ciudadList = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarSexo() {
    let data = {
      filters: { nombre: 'sexo', vigente: true },
      count: -1
    }
    this.dominioService.listar(data).subscribe(
      resp => {
        this.sexoList = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarEstadoCivil() {
    let data = {
      filters: { nombre: 'estado_civil', vigente: true },
      count: -1
    }
    this.dominioService.listar(data).subscribe(
      resp => {
        this.estadoCivilList = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarTiposDocumentos() {
    let data = {
      filters: { nombre: 'tipo_documento', vigente: true },
      count: -1
    }
    this.dominioService.listar(data).subscribe(
      resp => {
        this.tiposDocumentos = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarOficinasComerciales() {
    let data = {
      count: -1
    }
    this.oficinaComercialService.listar(data).subscribe(
      resp => {
        this.oficinasComerciales = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  solicitar() {
    let data = JSON.parse(JSON.stringify(deleteEmptyData(this.dataForm.value)));
    data.fechaNacimiento = new Date(data.fechaNacimiento.year, data.fechaNacimiento.month - 1, data.fechaNacimiento.day);

    delete data.termino;
    console.log(data);
    console.log(this.dataForm.value);

    this.service.solicitar(data).subscribe(
      (resp: any) => {
        this.toastr.success('Favor verifique su correo electrónico y siga las instrucciones', 'Registro Exitoso');
        this.dataForm.reset();
        this.router.navigate([''],{queryParams: {'hb':'1'}});
      }, err => {
        this.toastr.error((err.error.messages) ? err.error.messages[0] : err.error, 'Error');
      }
    );
  }

}
